import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiDialog from '@material-ui/core/Dialog';
import { combineClasses, styled, useDeprecatedCheck, useRcPortalWindowContext, useThemeProps, } from '../../foundation';
import { useUnmountPortalHandler } from '../PortalHost';
import { DialogStyle } from './styles';
import { RcDialogClasses } from './utils';
import { RcDialogContext } from './utils/DialogContext';
import { HasPortalParentProvider } from '../PortalHost/context/HasPortalParentContext';
import { RcBackdrop } from '../Backdrop';
var _RcDialog = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDialog' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcDialog, props, [
            {
                prop: 'size',
                time: '2021-11',
                comment: "\n     * please use `maxWidth` and `fullScreen` directly\n     *\n     * - 'fullScreen' => false\n     * - 'large' => `md`\n     * - 'medium' => `sm`\n     * - 'small' => `xs`\n     * - 'xsmall' => no longer exist, should custom by yourself\n     */",
            },
        ]);
    }
    var classesProp = props.classes, _a = props.size, size = _a === void 0 ? 'medium' : _a, maxWidthProp = props.maxWidth, _b = props.fullWidth, fullWidth = _b === void 0 ? true : _b, childrenSize = props.childrenSize, children = props.children, TransitionPropsProp = props.TransitionProps, PaperPropsProp = props.PaperProps, rest = __rest(props, ["classes", "size", "maxWidth", "fullWidth", "childrenSize", "children", "TransitionProps", "PaperProps"]);
    var classes = useMemo(function () { return combineClasses(RcDialogClasses, classesProp); }, [classesProp]);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    var maxWidth = useMemo(function () {
        if (maxWidthProp)
            return maxWidthProp;
        switch (size) {
            case 'fullScreen':
            case 'xsmall':
                return false;
            case 'large':
                return 'md';
            case 'medium':
                return 'sm';
            case 'small':
            default:
                return 'xs';
        }
    }, [maxWidthProp, size]);
    var contextValue = useMemo(function () { return ({ size: childrenSize }); }, [childrenSize]);
    var onExited = useUnmountPortalHandler(TransitionPropsProp === null || TransitionPropsProp === void 0 ? void 0 : TransitionPropsProp.onExited);
    var TransitionProps = __assign(__assign({ 
        // TODO: remove after upgrade to mui v5
        role: 'presentation' }, TransitionPropsProp), { onExited: onExited });
    var PaperProps = __assign({ 'aria-modal': true }, PaperPropsProp);
    return (React.createElement(HasPortalParentProvider, null,
        React.createElement(MuiDialog, __assign({ ref: ref, fullWidth: fullWidth, container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body, maxWidth: maxWidth, fullScreen: size === 'fullScreen' ? true : undefined, classes: classes, TransitionProps: TransitionProps, PaperProps: PaperProps, BackdropComponent: RcBackdrop }, rest),
            React.createElement(RcDialogContext.Provider, { value: contextValue }, children))));
});
var RcDialog = styled(_RcDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DialogStyle);
RcDialog.defaultProps = {};
RcDialog.displayName = 'RcDialog';
export { RcDialog, RcDialogContext };
var templateObject_1;
